// extracted by mini-css-extract-plugin
module.exports = {"is-invalid":"VInput_is-invalid_1Bzx6","error":"VInput_error_25Hj-"};